import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { CodeLogin, CodeLoginOld } from '@gripp/shared-ui';
import { useNavigate } from 'react-router-dom';
import { AuthSplitLayout } from './authSplitLayout';

export const Login = () => {
  const navigate = useNavigate();
  const isCropCircleRedesign = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );
  const handleRedirect = async (redirectPath: string) => {
    navigate(redirectPath);
    return Promise.resolve();
  };

  if (isCropCircleRedesign) {
    return (
      <AuthSplitLayout>
        <CodeLogin
          handleRedirect={handleRedirect}
          onCodeSent={() => navigate('/verify-auth-code')}
          onRegister={() => navigate('/register')}
        />
      </AuthSplitLayout>
    );
  }

  return (
    <CodeLoginOld
      handleRedirect={handleRedirect}
      onCodeSent={() => navigate('/verify-auth-code')}
      onRegister={() => navigate('/register')}
    />
  );
};
